/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks(props) {
  let location = useLocation();
  const { routes } = props;

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        const isActive = activeRoute(route.path);
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className={`relative mb-2 flex hover:cursor-pointer rounded-xl transition-all duration-200 ${
              isActive 
                ? "bg-[#4a7bb6] shadow-lg" 
                : "hover:bg-white/10"
            }`}>
              <li className="flex cursor-pointer items-center px-4 py-3 w-full" key={index}>
                <span className={`flex items-center justify-center w-8 h-8 rounded-lg transition-colors ${
                  isActive 
                    ? "bg-white/20 text-white" 
                    : "text-slate-400 group-hover:text-slate-300"
                }`}>
                  {route.icon ? route.icon : <DashIcon />}
                </span>
                <p className={`ml-3 font-medium transition-colors ${
                  isActive 
                    ? "text-white font-semibold" 
                    : "text-slate-300 hover:text-white"
                }`}>
                  {route.name}
                </p>
                {isActive && (
                  <div className="ml-auto">
                    <div className="w-2 h-2 rounded-full bg-white/60"></div>
                  </div>
                )}
              </li>
            </div>
          </Link>
        );
      }
    });
  };
  return createLinks(routes);
}

export default SidebarLinks;